export default __webpack_public_path__ + "static/media/testing-white.a012f10f.svg";